<template>
  <div style="width:100%;height:100%;">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>推广审核</span>
        <div>
          <span style="margin-right:15px">商品类型:</span>
          <el-select v-model="chooseType" placeholder="请选择" @change="choosetTypeChange">
            <el-option v-for="item in typeChooseList" :label="item" :value="item"></el-option>
          </el-select>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%" height="500px">
        <el-table-column prop="name" label="店主账号"></el-table-column>
        <el-table-column prop="name" label="推广账号"></el-table-column>
        <el-table-column prop="name" label="现场照片"></el-table-column>
        <el-table-column prop="name" label="提交时间"></el-table-column>

        <el-table-column prop="name" label="状态"></el-table-column>
        <el-table-column prop="name" label="操作"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      typeChooseList: ["已处理", "未处理"]
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `ExamineService/auditFailedMerchant/${this.infoData.id}` // 接口地址
      }).then(res => {});
    }
  }
};
</script>

<style>
</style>